import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModuleAccessService, CompanyModuleItem } from '../../services/module-access.service';

@Component({
  selector: 'app-modules',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './modules.component.html'
})
export class ModulesComponent implements OnInit {
  moduleForm: FormGroup;
  modules: CompanyModuleItem[] = [];
  selectedModuleId: number | null = null;
  isLoading = false;
  message = '';
  messageType: 'success' | 'error' = 'success';

  constructor(
    private fb: FormBuilder,
    private moduleAccessService: ModuleAccessService
  ) {
    this.moduleForm = this.fb.group({
      code: ['', [Validators.required]],
      name: ['', [Validators.required]],
      active: [true]
    });
  }

  ngOnInit(): void {
    this.load();
  }

  load() {
    this.isLoading = true;
    const companyId = this.moduleAccessService.getLoggedCompanyId();
    this.moduleAccessService.getCompanyModules(companyId).subscribe({
      next: ({ data }) => {
        this.modules = data ?? [];
        this.isLoading = false;
      },
      error: () => {
        this.showMessage('Erro ao carregar módulos', 'error');
        this.isLoading = false;
      }
    });
  }

  saveModule() {
    if (this.moduleForm.invalid) {
      this.moduleForm.markAllAsTouched();
      return;
    }

    const payload = {
      code: (this.moduleForm.value.code as string).trim().toLowerCase(),
      name: (this.moduleForm.value.name as string).trim(),
      active: !!this.moduleForm.value.active
    };

    const request$ = this.selectedModuleId
      ? this.moduleAccessService.updateModule(this.selectedModuleId, payload)
      : this.moduleAccessService.createModule(payload);

    request$.subscribe({
      next: () => {
        this.showMessage('Módulo salvo com sucesso', 'success');
        this.cancelEdit();
        this.load();
      },
      error: (error) => {
        this.showMessage(error?.error?.message ?? 'Erro ao salvar módulo', 'error');
      }
    });
  }

  editModule(item: CompanyModuleItem) {
    this.selectedModuleId = item.moduleId;
    this.moduleForm.patchValue({
      code: item.code,
      name: item.name,
      active: item.active
    });
  }

  cancelEdit() {
    this.selectedModuleId = null;
    this.moduleForm.reset({ code: '', name: '', active: true });
  }

  deleteModule(item: CompanyModuleItem) {
    if (!confirm(`Deseja remover o módulo ${item.name}?`)) {
      return;
    }

    this.moduleAccessService.deleteModule(item.moduleId).subscribe({
      next: () => {
        this.showMessage('Módulo removido com sucesso', 'success');
        this.load();
      },
      error: () => this.showMessage('Erro ao remover módulo', 'error')
    });
  }

  toggleCompanyModule(item: CompanyModuleItem, enabled: boolean) {
    const companyId = this.moduleAccessService.getLoggedCompanyId();
    this.moduleAccessService.updateCompanyModules(companyId, [{ moduleId: item.moduleId, enabled }]).subscribe({
      next: ({ data }) => {
        this.modules = data ?? [];
        this.moduleAccessService.setEnabledModules(
          this.modules.filter((x) => x.active && x.enabled).map((x) => x.code)
        );
      },
      error: () => this.showMessage('Erro ao atualizar habilitação', 'error')
    });
  }

  private showMessage(message: string, type: 'success' | 'error') {
    this.message = message;
    this.messageType = type;
    setTimeout(() => (this.message = ''), 4000);
  }
}
